import {
  disableScroll,
  enableScroll,
  isIOS,
  isMobile,
} from "@/utils/chartUtil.js";
import trash_icon_mb from "@/assets/images/icons/trash_icon_mb.png";
import add_line_icon_mb from "@/assets/images/icons/add_line_icon_mb.png";
import add_line_icon_filled from "@/assets/images/icons/add_line_icon_filled.png";
import enter_full_icon_mb from "@/assets/images/icons/enter_full_icon_mb.png";
import exit_full_icon_mb from "@/assets/images/icons/exit_full_icon_mb.png";
import ruler_icon from "@/assets/images/icons/ruler_icon.png";
import ruler_icon_active from "@/assets/images/icons/ruler_icon_active.png";

let windowWidth = window.innerWidth;

export let createToolBox = async (container) => {
  let svgContainer = document.createElement("div");
  svgContainer.className = "svg_container";

  let deletePriceLine = document.createElement("div");
  deletePriceLine.className = "deletePriceLine";
  deletePriceLine.innerHTML = `
    <img src="${trash_icon_mb}" class=""></img>
    `;
  svgContainer.appendChild(deletePriceLine);

  let drawPriceLine = document.createElement("div");
  drawPriceLine.className = "drawPriceLine";
  drawPriceLine.innerHTML = `
    <img src="${add_line_icon_mb}" class=""></img>
    `;
  svgContainer.appendChild(drawPriceLine);

  let enterFullscreenBtn = document.createElement("div");
  enterFullscreenBtn.className = "enterFullscreenBtn";
  enterFullscreenBtn.innerHTML = `
    <img src="${enter_full_icon_mb}" class=""></img>
    `;
  svgContainer.appendChild(enterFullscreenBtn);

  let exitFullscreenBtn = document.createElement("div");
  exitFullscreenBtn.className = "exitFullscreenBtn";
  exitFullscreenBtn.innerHTML = `
    <img src="${exit_full_icon_mb}" class=""></img>
    `;
  svgContainer.appendChild(exitFullscreenBtn);

  let rulerBtn = document.createElement("div");
  rulerBtn.className = "rulerBtn";
  rulerBtn.innerHTML = `
    <img src="${ruler_icon}" class="ruler-icon"></img>
    `;
  svgContainer.appendChild(rulerBtn);

  container.appendChild(svgContainer);
};

let isMeasureMode = false;
let startPoint = null;
let measureRect = null;
let overlay = null;

// 오버레이 캔버스 설정 ( 차트에 캔버스 그림 보여주기 )
function setupOverlay(container) {
  overlay = document.createElement("canvas");
  overlay.style.position = "absolute";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.pointerEvents = "none";
  overlay.style.zIndex = 9999;
  container.appendChild(overlay);
  const ctx = overlay.getContext("2d");
  resizeOverlay(container);

  // 화면 리사이즈 시 캔버스 크기 조정
  // window.addEventListener("resize", () => {
  //   resizeOverlay(container);
  // });

  return ctx;
}
// 화면 사이즈 따라  캔버스 사이즈도 변경
export function resizeOverlay(container, type) {
  if (type === "smart" && type !== "premium") {
    // console.log(type);
    setTimeout(() => {
      const rect = container.getBoundingClientRect();

      overlay.width = rect.width;
      overlay.height = rect.height;
    }, 300);
  }
}

// 측정도구 아이콘에 이벤트 추가
export function createMeasureButton(container) {
  let measureButton = container.getElementsByClassName("rulerBtn")[0];
  measureButton.onclick = toggleMeasureTool;
}
// 클릭시 아이콘 이미지 변경 및 측정모드아닐때 캔버스 초기화
function toggleMeasureTool() {
  isMeasureMode = !isMeasureMode;
  this.classList.toggle("active");
  this.querySelector("img").src = isMeasureMode
    ? ruler_icon_active
    : ruler_icon;
  // if (!isMeasureMode) {
  //     // 측정 도구 비활성화시 모든 상태 초기화
  //     clearMeasurement(ctx);
  //     chart.applyOptions({
  //         handleScroll: {
  //             horzTouchDrag: true,
  //             vertTouchDrag: true,
  //         }
  //     });
  // }
}

// 측정 지우기
function clearMeasurement(ctx) {
  startPoint = null;
  // const ctx = overlay.getContext('2d');
  // ctx.clearRect(0, 0, overlay.width, overlay.height);
  if (ctx && overlay) {
    ctx.clearRect(0, 0, overlay.width, overlay.height);
  }
}

// 측정값 그리기
function drawMeasurement(chart, ctx, currentPoint, container) {
  if (!startPoint || !currentPoint) return;

  // 가격 차이 계산 (클릭 이벤트의 price 정보 사용)
  const priceDiff = currentPoint.price - startPoint.price;
  const percentChange = (priceDiff / startPoint.price) * 100;

  const rect = container.getBoundingClientRect();

  overlay.width = rect.width;
  overlay.height = rect.height;

  ctx.clearRect(0, 0, overlay.width, overlay.height);

  // 직사각형 배경 그리기
  const rectWidth = currentPoint.x - startPoint.x;
  const rectHeight = currentPoint.y - startPoint.y;

  ctx.fillStyle =
    priceDiff > 0 ? "rgba(57, 81, 160, 0.61)" : "rgba(253, 16, 87, 0.1)";
  ctx.fillRect(startPoint.x, startPoint.y, rectWidth, rectHeight);

  ctx.strokeStyle = "transparent";
  ctx.lineWidth = 1;
  ctx.strokeRect(startPoint.x, startPoint.y, rectWidth, rectHeight);

  // 툴팁 크기 설정
  const tooltipWidth = 150;
  const tooltipHeight = 35;

  // x축 중앙 위치 계산
  const centerX = startPoint.x + rectWidth / 2;

  // rect 아래쪽에서 10px 떨어진 위치 계산
  const bottomY = Math.max(startPoint.y, currentPoint.y) + 10;

  // 툴팁 위치 계산 (x축 중앙, y축은 rect 아래)
  const tooltipX = centerX - tooltipWidth / 2;
  const tooltipY = bottomY;

  // 측정값 표시
  ctx.font = "12px Arial";
  ctx.fillStyle = priceDiff > 0 ? "#2962FF" : "#fd606c";

  // 툴팁 배경 그리기
  ctx.beginPath();
  ctx.roundRect(tooltipX, tooltipY, tooltipWidth, tooltipHeight, 5);
  ctx.fill();
  // 텍스트 중앙 정렬을 위한 설정
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  // 텍스트 색상 설정
  ctx.fillStyle = "#fff";

  // 툴팁의 중앙 좌표 계산
  const tooltipCenterX = tooltipX + tooltipWidth / 2;
  const tooltipCenterY = tooltipY + tooltipHeight / 2;
  // 텍스트 그리기
  ctx.fillText(
    `${priceDiff.toFixed(5)} (${percentChange.toFixed(2)}%)`,
    tooltipCenterX,
    tooltipCenterY
  );
  // ctx.fillText(
  //     `변화율: ${percentChange.toFixed(2)}%`,
  //     tooltipCenterX + 10,
  //     tooltipCenterY + 15
  // );
}
// 이벤트 핸들러 설정
//  setupEventHandlers => 캔버스 생성해서 차트 클릭시 필요한 두가격 가져오기
export function setupEventHandlers(container, chart, series) {
  const ctx = setupOverlay(container);
  const setChartDragEnabled = (enabled) => {
    chart.applyOptions({
      handleScroll: {
        horzTouchDrag: enabled,
        vertTouchDrag: enabled,
      },
    });
  };
  // 차트에 클릭이벤트 추가
  chart.subscribeClick((param) => {
    if (!isMeasureMode) {
      // 측정모드 아닐때 캔버스 초기화
      clearMeasurement(ctx);
      return;
    }

    if (!startPoint) {
      // 첫 번째 클릭: 시작점 저장
      startPoint = {
        x: param.point.x,
        y: param.point.y,
        price: series.coordinateToPrice(param.point.y), // 시리즈의 가격 정보
      };
      setChartDragEnabled(false);
    } else {
      // 두 번째 클릭: 측정 완료
      const currentPoint = {
        x: param.point.x,
        y: param.point.y,
        price: series.coordinateToPrice(param.point.y), // 시리즈의 가격 정보
      };
      drawMeasurement(chart, ctx, currentPoint, container);
      startPoint = null; // 다 그린다음에 처음시작점 초기화
      setChartDragEnabled(true);
      isMeasureMode = false;
      const rulerBtn = container.querySelector(".rulerBtn");
      rulerBtn.classList.remove("active");
      rulerBtn.querySelector("img").src = ruler_icon;
    }
  });
  // const originalToggleMeasureTool = toggleMeasureTool;
  // toggleMeasureTool = function() {
  //     originalToggleMeasureTool.call(this);
  //     if (!isMeasureMode) {
  //         // 측정 모드 종료 시 드래그 활성화
  //         setChartDragEnabled(true);
  //         startPoint = null;
  //     }
  // };
  // container.addEventListener('mousemove', (e) => {
  //     if (!isMeasureMode || !startPoint) return;

  //     const rect = container.getBoundingClientRect();
  //     const mousePoint = {
  //         x: e.clientX - rect.left,
  //         y: e.clientY - rect.top
  //     };

  //     // 마우스 이동 중의 가격 정보 얻기
  //     const price = series.coordinateToPrice(mousePoint.y);

  //     const currentPoint = {
  //         x: mousePoint.x,
  //         y: mousePoint.y,
  //         price: price
  //     };

  //     drawMeasurement(chart, ctx, currentPoint);
  // });
  // 마우스 이벤트
  container.addEventListener("mousemove", (e) => {
    handlePointerMove(e, container, chart, series, ctx);
  });

  // 터치 이벤트
  container.addEventListener("touchmove", (e) => {
    e.preventDefault(); // 스크롤 방지
    const touch = e.touches[0];
    handlePointerMove(touch, container, chart, series, ctx);
  });
}

function handlePointerMove(event, container, chart, series, ctx) {
  if (!isMeasureMode || !startPoint) return;

  const rect = container.getBoundingClientRect();
  const currentPoint = {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  };

  // 시리즈에서 가격 정보 가져오기
  if (series) {
    currentPoint.price = series.coordinateToPrice(currentPoint.y);
    drawMeasurement(chart, ctx, currentPoint, container);
  }
}

export let setAutoBtn = (container, chart) => {
  let scrollNum = undefined;
  let autoScaleBtn;
  autoScaleBtn = container.getElementsByClassName("autoScaleBox")[0];
  if (autoScaleBtn) {
    autoScaleBtn.addEventListener("click", function () {
      chart.timeScale().resetTimeScale();
      chart.timeScale().scrollToPosition(0, false);
      chart.priceScale("right").applyOptions({
        autoScale: true,
      });
      autoScaleBtn.style.color = "var(--text-orange)";
      scrollNum = chart.timeScale().scrollPosition();
      // console.log('before subscribe', scrollNum);
      setTimeout(() => {
        chart.timeScale().subscribeVisibleTimeRangeChange((timeRange) => {
          visibleTimeRangeChangeHandler(
            timeRange,
            chart,
            autoScaleBtn,
            scrollNum
          );
        });
      }, 1000);
    });
  }
};

let visibleTimeRangeChangeHandler = (
  newVisibleTimeRange,
  chart,
  autoScaleBtn,
  scrollNum
) => {
  // console.log('newVisibleTimeRange',newVisibleTimeRange);
  if (newVisibleTimeRange === null) {
    // console.log('현재 보이는 데이터가 없습니다.');
    autoScaleBtn.style.color = "#fff";
  } else {
    // console.log('number', scrollNum);
    const currentScrollPosition = chart.timeScale().scrollPosition();
    // console.log('currentNumber', currentScrollPosition);
    autoScaleBtn.style.color = "var(--text-orange)";
    if (currentScrollPosition !== 0 && scrollNum != currentScrollPosition) {
      autoScaleBtn.style.color = "#fff";
    }
  }
};

export let drawingToolHandler = (container, chart, series) => {
  let lineNum = 1;
  let priceLines = [];
  let clickHandlerAdded = false;
  // clickHandlerAdded = false;
  let drawPriceLine = container.getElementsByClassName("drawPriceLine")[0];
  let deletePriceLine = container.getElementsByClassName("deletePriceLine")[0];
  // console.log(series);
  let clickHandler = (param) =>
    clickPriceHandler(param, series, lineNum, priceLines);

  drawPriceLine.addEventListener("click", function () {
    if (!clickHandlerAdded) {
      // 클릭 이벤트 핸들러 등록
      chart.subscribeClick(clickHandler);
      clickHandlerAdded = true; // 플래그를 true로 설정하여 등록 상태로 변경
      // console.log(clickHandlerAdded);
      drawPriceLine.querySelector("img").src = add_line_icon_filled;
    } else {
      // 클릭 이벤트 핸들러 해제
      chart.unsubscribeClick(clickHandler);
      clickHandlerAdded = false; // 플래그를 false로 설정하여 해제 상태로 변경
      // console.log(clickHandlerAdded);
      drawPriceLine.querySelector("img").src = add_line_icon_mb;
    }
  });
  deletePriceLine.addEventListener("click", function () {
    if (priceLines.length > 0) {
      const lastLine = priceLines.shift();
      // 해당 priceLine 삭제
      series.removePriceLine(lastLine);
      // console.log(priceLines);
    }
  });
};

let clickPriceHandler = (param, series, lineNum, priceLines) => {
  // console.log('series',series);

  if (!param.point) {
    return;
  }
  const covertPrice = series.coordinateToPrice(param.point.y);
  // console.log(covertPrice);

  // 가격 선 추가
  const lineName = series.createPriceLine({
    // id:lineNum,
    price: covertPrice,
    color: "#fff",
    lineWidth: 2,
    lineStyle: 0,
    axisLabelVisible: false,
    title: "Line" + lineNum,
  });
  // console.log(lineName.options());
  // 생성된 priceLine을 배열에 추가
  priceLines.push(lineName);
  // console.log(priceLines);
  lineNum++; // 다음 선을 위해 카운트 증가
};

export let fullScreenHandler = (state, parent, container, chart) => {
  let enterFullscreenBtn =
    container.getElementsByClassName("enterFullscreenBtn")[0];
  let exitFullscreenBtn =
    container.getElementsByClassName("exitFullscreenBtn")[0];
  exitFullscreenBtn.style.display = "none";
  let scrollTop = document.querySelector(".scroll_top");
  enterFullscreenBtn.addEventListener("click", function () {
    if (scrollTop) {
      scrollTop.style.display = "none";
    }
    state.isFull = true;
    if (isIOS()) {
      parent.style.width = "100vw";
      parent.style.height = `${state.adjustedHeight}px`;
      parent.style.margin = 0;
      parent.style.padding = 0;
      parent.style.position = "fixed";
      parent.style.top = 0;
      parent.style.left = 0;
      parent.style.zIndex = 99999;
      parent.style.background = "#151515";
      setTimeout(() => {
        resizeChartToParent(parent, container, state.isFull, chart);
      }, 300);
      // console.log("이 기기는 IOS 입니다.");
      disableScroll();
    } else {
      parent.style.height = "100vh";
      parent.style.width = "100vw";
      setTimeout(() => {
        resizeChartToParent(parent, container, state.isFull, chart);
      }, 300);
      fullscreen(parent);
      // console.log('window',window.innerHeight);
    }
    if (scrollTop) {
      scrollTop.style.display = "none";
    }
    enterFullscreenBtn.style.display = "none";
    exitFullscreenBtn.style.display = "block";
  });

  exitFullscreenBtn.addEventListener("click", (e) => {
    state.isFull = false;
    chart.applyOptions({
      autoSize: true,
    });
    e.preventDefault();
    if (isIOS()) {
      parent.style.width = "100%";
      parent.style.height = "650px";
      parent.style.margin = 0;
      parent.style.padding = 0;
      parent.style.position = "static";
      enableScroll();
      setTimeout(() => {
        resizeChartToParent(parent, container, state.isFull, chart);
      }, 300);
    } else {
      exitFullScreen();
    }
    enterFullscreenBtn.style.display = "block";
    exitFullscreenBtn.style.display = "none";
    if (scrollTop) {
      scrollTop.style.display = "block";
    }
  });

  document.addEventListener("fullscreenchange", () =>
    fullScreenChangeHandler(state, parent, container, chart)
  );
};

let fullScreenChangeHandler = (state, parent, container, chart) => {
  // console.log('full screen change');

  let enterFullscreenBtn =
    container.getElementsByClassName("enterFullscreenBtn")[0];
  let exitFullscreenBtn =
    container.getElementsByClassName("exitFullscreenBtn")[0];
  let scrollTop = document.querySelector(".scroll_top");
  if (!document.fullscreenElement) {
    // console.log('exit fullscreen');

    parent.style.width = "100%";
    if (windowWidth <= 576 || isMobile()) {
      parent.style.height = "650px";
    } else {
      parent.style.height = "700px";
    }

    enterFullscreenBtn.style.display = "block";
    exitFullscreenBtn.style.display = "none";
    state.isFull = false;
    setTimeout(() => {
      resizeChartToParent(parent, container, state.isFull, chart);
    }, 300);
    chart.applyOptions({
      autoSize: true,
    });
    if (scrollTop) {
      scrollTop.style.display = "block";
    }
  } else {
    state.isFull = true;
    parent.style.height = "100vh";
    parent.style.width = "100vw";
    enterFullscreenBtn.style.display = "none";
    exitFullscreenBtn.style.display = "block";
    if (scrollTop) {
      scrollTop.style.display = "none";
    }
    setTimeout(() => {
      resizeChartToParent(parent, container, state.isFull, chart);
    }, 300);
  }
};

let resizeChartToParent = (parent, container, isFull, chart) => {
  const parentWidth = parent.offsetWidth;
  let parentHeight = parent.offsetHeight;

  // 차트를 부모 요소의 넓이와 높이에 맞게 조정
  // console.log('chart height',parentHeight-selectContainerHeight);
  // console.log('windowWidth',windowWidth);
  if (windowWidth <= 576 || isMobile()) {
    let selectContainerHeight = document.querySelector(
      ".select_container.mobile"
    )
      ? document.querySelector(".select_container.mobile").offsetHeight
      : 0;
    if (isFull == false) {
      // console.log('모바일 사이즈','부모',parentHeight,"차트크기",parentHeight-selectContainerHeight);
      parentHeight = 650;
      chart.resize(parentWidth, parentHeight - selectContainerHeight, true);
      container.style.height = `${parentHeight - selectContainerHeight}px`;
    } else {
      chart.resize(parentWidth, parentHeight - selectContainerHeight, true);
      container.style.height = `${parentHeight - selectContainerHeight}px`;
    }
  } else {
    container.style.height = "100%";
    chart.resize(parentWidth, parentHeight);
    // console.log('웹 높이',parentHeight,container.style.height);
  }
};

let fullscreen = (element) => {
  if (element.requestFullscreen) return element.requestFullscreen();
  if (element.webkitRequestFullscreen) return element.webkitRequestFullscreen();
  if (element.mozRequestFullScreen) return element.mozRequestFullScreen();
  if (element.msRequestFullscreen) return element.msRequestFullscreen();
  if (element.webkitIsFullScreen) return element.webkitIsFullScreen();
  if (element.webkitRequestFullscreen)
    return element.webkitCurrentFullScreenElement();
};

let exitFullScreen = () => {
  if (document.exitFullscreen) return document.exitFullscreen();
  if (document.webkitCancelFullscreen) return document.webkitCancelFullscreen();
  if (document.mozCancelFullScreen) return document.mozCancelFullScreen();
  if (document.msExitFullscreen) return document.msExitFullscreen();
  //   if (element.webkitIsFullScreen) return element.webkitIsFullScreen();
};
